
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Settings from "../../modules/settings/Settings";
export default Settings;
export function getStaticPaths({ locales = [], }: {
    locales?: string[];
}) {
    const pages = [0, 1, 2, 3, 4, 5, 6];
    const basePaths = pages.map((page) => ({
        params: {
            page: page.toString(),
        },
    }));
    const paths = locales.length > 0
        ? locales.flatMap((locale) => basePaths.map((path) => ({ ...path, locale })))
        : basePaths;
    return {
        paths,
        fallback: true,
    };
}
const getStaticProps = async ({ params }) => {
    const { page } = params;
    return {
        props: { page },
    };
};

    async function __Next_Translate__getStaticProps__19cec0e0e59__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/settings/[page]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19cec0e0e59__ as getStaticProps }
  